import { HeaderFromPage } from "../../components/common/HeaderFormPage";
import styles from "./Login.module.scss";
import { LoginForm } from "../../components/LoginFrom";
import { Link, useLocation } from "react-router-dom";

export const Login = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderFromPage title='WELCOME' subtitle='Login' />
      <p className={styles.text}>
        Welcome to the Startup Library, login to continue:
      </p>
      <LoginForm />
      <p className={styles.textBottom}>
        Forgot password? No problem,&nbsp;
        <strong>
          <Link to='/request-change-password' className={styles.link}>
            Click here
          </Link>
        </strong>
        .
      </p>
    </div>
  );
};

// Login.propTypes = {
//     setToken: PropTypes.func.isRequired
// }
